import BaseCell from '../base-cell';
import Inner from './inner';
import { fn, array, hash } from '@ember/helper';
import { LinkTo } from '@ember/routing';
import or from 'ember-truth-helpers/helpers/or';
import BvUnstyledBtn from 'volta/components/bv-unstyled-btn';
import orElse from 'volta/helpers/or-else';

import type { TemplateOnlyComponent } from '@ember/component/template-only';

interface CellPlanningPriorityCellSignature {
  Args: {
    cell: unknown;
    column: unknown;
    row: unknown;
  };
}

const CellPlanningPriorityCellComponent = <template>
  {{! @glint-nocheck: not typesafe yet }}
  <BaseCell
    @cell={{@cell}}
    @row={{@row}}
    @column={{@column}}
    class='planning-priority-cell'
    as |baseCell|
  >
    {{#unless baseCell.value.hide}}
      {{#if (or baseCell.value.route baseCell.value.action)}}
        {{#if baseCell.value.action}}
          <BvUnstyledBtn
            class='u-full-width u-text-left'
            @onClick={{if
              baseCell.value.action
              (fn baseCell.value.action (orElse baseCell.value.model baseCell.model))
            }}
          >
            <Inner @value={{baseCell.value}} />
          </BvUnstyledBtn>
        {{else}}
          <LinkTo
            class='u-full-width u-unstyled-link'
            @route={{baseCell.value.route}}
            @models={{orElse
              baseCell.value.routeModels
              (if baseCell.value.routeModel (array baseCell.value.routeModel) (array))
            }}
            @query={{orElse baseCell.value.routeQuery (hash)}}
          >
            <Inner @value={{baseCell.value}} />
          </LinkTo>
        {{/if}}
      {{else}}
        <Inner @value={{baseCell.value}} />
      {{/if}}
    {{/unless}}
  </BaseCell>
</template> satisfies TemplateOnlyComponent<CellPlanningPriorityCellSignature>;

export default CellPlanningPriorityCellComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Cell::PlanningPriorityCell': typeof CellPlanningPriorityCellComponent;
    'cell/planning-priority-cell': typeof CellPlanningPriorityCellComponent;
  }
}
